/**
 * Tiny date helper used everywhere we need "today" in YYYY-MM-DD form for
 * sending to the backend or comparing to a stored date string.
 *
 * date-fns `format(new Date(), 'yyyy-MM-dd')` already uses local time, but
 * being explicit here removes any possibility of an off-by-one across
 * timezones / DST and gives us a single, obvious source of truth.
 */
export function todayLocalDateStr(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
